import { render, staticRenderFns } from "./ClubPerformance.vue?vue&type=template&id=725620e8&scoped=true"
import script from "./ClubPerformance.vue?vue&type=script&lang=js"
export * from "./ClubPerformance.vue?vue&type=script&lang=js"
import style0 from "./ClubPerformance.vue?vue&type=style&index=0&id=725620e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725620e8",
  null
  
)

export default component.exports